// /src/_features/objectCustomization/state/slice.js
//
// Slimmed during the Object Customization migration (see
// docs/bug-sheet.md): this slice is genuinely shared infrastructure -
// `objectCustomizations`/`setObjectCustomizations` are consumed directly by
// 9 other already-migrated `_features` pages plus `_features/auth`'s
// org-switch hook, cross-feature reads into this feature's own state -
// same accepted pattern as several other shared slices/API files in the
// app. Everything else that used to live here (`selectedObject`,
// `editMode`, `draftFields`, `searchQuery`,
// `modalMode`, `fieldToEdit`, `openFieldModal`, `showConfirmationModal`,
// `confirmationAction`, `selectedField`, `isMobileMenuOpen`,
// `openFieldVisibility`, `openFieldActionables`) was page-local UI state
// with zero external consumers (verified by grep) - moved to local React
// state in `_features/objectCustomization/hooks/useObjectCustomizationActions.js`.
// `openNewObjectSubType`/`openDefaultTable`/`openCustomTable` were dropped
// outright - dead in the old code too, never dispatched or read by anything.
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  objectCustomizations: null,
};

const objectCustomizationSlice = createSlice({
  name: "objectCustomizationFeature",
  initialState,
  reducers: {
    setObjectCustomizations(state, action) {
      state.objectCustomizations = action.payload;
    },
  },
});

export const { setObjectCustomizations } = objectCustomizationSlice.actions;

export default objectCustomizationSlice.reducer; 